import React, { useContext } from "react";
import { AppContext } from "@vahak/core/dist/app-context";
import AppImg from "components/utils/AppImg";
import StoryColon from "@vahak/core/dist/icons/StoryColon.svg";

import Styles from "./Story.module.scss";

export interface StoryProps {
    imgSrcLarge?: string;
    author?: string;
    authorPosition?: string;
    text?: string;
}

const Story = ({ imgSrcLarge, author, authorPosition, text }: StoryProps) => {
    const { isMobile } = useContext(AppContext);

    return (
        <div className={Styles.wrapper}>
            <div className={Styles.imgBox}>
                <AppImg
                    src={`${imgSrcLarge}`}
                    alt={author + ", " + authorPosition + ", Vahak"}
                    layout="responsive"
                    width={isMobile ? "267" : "410"}
                    height={isMobile ? "231" : "356"}
                />
            </div>
            <div className={Styles.textBox}>
                <span className={Styles.colonImg}>
                    <StoryColon width="39.2" height="28.2" />
                </span>
                <p>{text}</p>
                <span className={Styles.author}>{author}</span>
                <span className={Styles.authorPosition}>{authorPosition}</span>
            </div>
        </div>
    );
};

export default Story;
